import React from 'react';
import { Link } from 'react-router-dom';

import loc from 'sources/locale/loc';
import { LogButton } from 'components/controls';
import withUserRole from 'decorators/withUserRole';
import { LogoIcon } from 'icons';
import styles from './SiteNavBar.scss';
import AdminButtons from './AdminButtons';
import GuestButtons from './GuestButtons';
import SiteNavBarDropDownMenu from './SiteNavBarDropDownMenu';

function SiteNavBar(props) {
  const { role } = props;

  const renderRoleMenu = () => {
    if (role.isAdmin()) {
      return <AdminButtons />;
    }

    if (role.isGuest()) {
      return <GuestButtons />;
    }

    return null;
  };

  return (
    <header className={styles.container}>
      <Link to="/" className={styles.logo}>
        <LogoIcon className={styles.logoIcon} />
        <img
          src={`/static/images/label.svg`}
          alt={loc('potion-title')}
          className={styles.label}
        />
      </Link>
      <nav className={styles.right}>
        {renderRoleMenu()}
        {!role.isGuest() && <LogButton />}
      </nav>
      <SiteNavBarDropDownMenu className={styles.mobileMenu}>
        <nav className={styles.rightMobile}>
          {renderRoleMenu()}
          {!role.isGuest() && <LogButton />}
        </nav>
      </SiteNavBarDropDownMenu>
    </header>
  );
}

export default withUserRole(SiteNavBar);



// WEBPACK FOOTER //
// ./src/components/SiteNavBar/SiteNavBar.jsx